import { useCallback } from 'react';
import { WorkflowSidebarButton } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useDisplayWebContent } from './hooks/useDisplayWebContent';
import { NodeIds } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';

export const displayWebContentButtonDragId = 'display-web-content';

export function DisplayWebContentButton() {
  const { t } = useTranslation('campaigns');
  const { addToFlow, onMessageDragged, onMessageDragEnd } = useDisplayWebContent();

  const onDrop = useCallback(
    (dropLocation: string) => {
      addToFlow(dropLocation ?? NodeIds.dropzone);
    },
    [addToFlow],
  );

  const onDrag = useCallback(() => {
    onMessageDragged();
  }, [onMessageDragged]);

  const onDragEnd = useCallback(() => {
    onMessageDragEnd();
  }, [onMessageDragEnd]);

  return (
    <WorkflowSidebarButton
      icon="browser"
      aria-label={t('onsite.editor.workflow.displayWebContentMessage.messageAria')}
      dragId={displayWebContentButtonDragId}
      onDrag={onDrag}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      onMouseOver={onDrag}
      onMouseOut={onDragEnd}
    >
      {t('onsite.editor.workflow.displayWebContentMessage.message')}
    </WorkflowSidebarButton>
  );
}
